// Import labels
import { EVENT } from '../resources/labels';

// Import directives
import cta from './cta';

// Click event listener
document.addEventListener(EVENT.CLICK, clickDirectives);

// Execute all click directives
function clickDirectives(evt) {
    cta(evt);
}